import JSONbig from 'json-bigint';
import {
  BaseApiService,
  responseInterceptor as baseInterceptor,
} from '~packages/json-api/client';
import type { InterceptorResponse } from '~packages/json-api/client';

import FileModuleApiService from './FileModuleApiService';

const JSONbigNative = JSONbig({ useNativeBigInt: true });

BaseApiService.unregister(baseInterceptor);

export default class BigIntModuleApiService extends FileModuleApiService {
  constructor(params = {}) {
    super({ ...params, pathFetchAll: '/', pathAdd: '/' });
  }

  jsonStringify(data: any) {
    return JSONbigNative.stringify(data);
  }
}

// const checkResponse = (data) => {
//   console.group('checkResponse');
//   try {
//     console.log(data);
//     const val = data.response.data[0].POINT_code;
//     console.log(val);
//     console.log(val.toString());
//   } catch (err) {
//     console.log('ERROR', err);
//   }
//   console.groupEnd();
// };

export const responseInterceptor: InterceptorResponse = async ({
  data,
  response,
  cb,
}) => {
  if (response.bodyUsed) return data;

  const contentType = response.headers.get('content-type');
  if (!contentType?.includes('application/json')) return data;

  // let dataProcessed = await response.json(); // default
  let dataProcessed = JSONbigNative.parse(await response.text()); // bigint

  if (cb) {
    dataProcessed = cb(dataProcessed);
  } else {
    const dataResult = dataProcessed?.data?.result;
    if (dataResult) dataProcessed = dataResult;
  }

  return dataProcessed;
};

BigIntModuleApiService.register(responseInterceptor, true);
